import { BrowserRouter as Router, Routes, Route, } from "react-router-dom";
import { lazy, Suspense } from "react";
import "../node_modules/bootstrap/dist/css/bootstrap.css";
import Preloader from "./layout/Preloader";
// Navigation Pages Main
const Home = lazy(() => import("./ui/Home"));
const Contact = lazy(() => import("./ui/Contact"));
const About = lazy(() => import("./ui/About"));
const StartQuery = lazy(() => import("./ui/StartQuery"));
// Page Not Found
const NoPage = lazy(() => import("./layout/NoPage"));
// Footer Pages
const Career = lazy(() => import("./ui/Career"));
// Services Pages
const WebDevelopment = lazy(() => import("./ui/Services/WebDevelopment"));
const AppDevelopment = lazy(() => import("./ui/Services/AppDevelopment"));
const UiUxDesign = lazy(() => import("./ui/Services/AppDevelopment"));
const SeoOptimization = lazy(() => import("./ui/Services/AppDevelopment"));
const DigitalMarketing = lazy(() => import("./ui/Services/AppDevelopment"));
const EmailMarketing = lazy(() => import("./ui/Services/AppDevelopment"));
const CustomSoftwareDevelopment = lazy(() => import("./ui/Services/AppDevelopment"));
const WebHostingServices = lazy(() => import("./ui/Services/AppDevelopment"));

function App() {
  return (
    <>
      <Router>
        <Suspense fallback={ <Preloader/>}>
          <Routes>
            {/* Navigation Pages Main */}
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/start-query" element={<StartQuery />} />
            {/* Services Pages */}
            <Route path="/web-development" element={<WebDevelopment />} />
            <Route path="/app-development" element={<AppDevelopment />} />
            <Route path="/ui-ux-design" element={<UiUxDesign />} />
            <Route path="/seo-optimization" element={<SeoOptimization />} />
            <Route path="/digital-marketing" element={<DigitalMarketing />} />
            <Route path="/email-marketing" element={<EmailMarketing />} />
            <Route path="/custom-software-development" element={<CustomSoftwareDevelopment />} />
            <Route path="/web-hosting-services" element={<WebHostingServices />} />
            {/* Footer Pages */}
            <Route path="careers" element={<Career />} />
            <Route path="*" element={<NoPage />} />       
          </Routes>
        </Suspense>
      </Router> 
    </>
  );
}

export default App;
